import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest
  const [demoMode, setDemoMode] = useState(sessionStorage.getItem("vgs_demo") === "1");
  const [viewScope, setViewScopeState] = useState(sessionStorage.getItem("vgs_scope") || "demo");

  const setViewScope = (v) => {
    sessionStorage.setItem("vgs_scope", v);
    setViewScopeState(v);
  };

  const checkAuth = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    sessionStorage.removeItem("vgs_demo");
    setDemoMode(false);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    sessionStorage.removeItem("vgs_demo");
    setDemoMode(false);
    setUser(false);
  };

  const enterDemo = () => {
    sessionStorage.setItem("vgs_demo", "1");
    setDemoMode(true);
  };

  const exitDemo = () => {
    sessionStorage.removeItem("vgs_demo");
    setDemoMode(false);
  };

  const scope = demoMode || (user && user.role === "demo") || viewScope === "demo" ? "demo" : undefined;
  const checking = user === null;

  return (
    <AuthContext.Provider value={{ user, setUser, demoMode, enterDemo, exitDemo, login, logout, scope, checking, viewScope, setViewScope }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
